import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

// WhatsApp de suporte: so para quem tem conta (toda conta nasce de uma compra).
// O numero vem do Admin, entao trocar la muda em todos os lugares.
export function useSuporte(ativo = true) {
  const [suporte, setSuporte] = useState(null);
  useEffect(() => {
    if (!ativo) return;
    axios.get(`${API}/suporte`).then((r) => setSuporte(r.data)).catch(() => {});
  }, [ativo]);
  return suporte;
}

export function linkWhatsApp(suporte, user) {
  const texto = `Olá! Sou cliente do Aesthetica Pricing (${user?.email || ""}). Preciso de ajuda com: `;
  return `${suporte.whatsapp_link}?text=${encodeURIComponent(texto)}`;
}
